import React, { useState, useEffect } from "react";
import { func, object } from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import axios from "axios";

import "./checkout-modal.m.css";
import { KayttoehdotPage } from "../../../kayttoehdot/kayttoehdot";

const currencyLabels = {
  EUR: "€",
};

export const CheckoutModal = ({ member, setActiveTab, initPaytrailPayment, selectedPlan, validateCoupon, selectedSubscriptionGroup = null, hasActiveSubscription }) => {
  const globalQtConfig = useSelector((state) => get(state, ["qt", "config"]));
  const publisherConfig = useSelector((state) => get(state, ["qt", "publisherConfig"], {}));
  const ATBaseUrl = get(globalQtConfig, ["publisher-attributes", "accesstypeConfig", "ATBaseUrl"], "");
  const ATKey = get(globalQtConfig, ["publisher-attributes", "accesstypeConfig", "key"], "");
  const ATOriginDomain = get(globalQtConfig, ["publisher-attributes", "accesstypeConfig", "originDomain"], "");
  const ATCouponGroupsIDs = get(globalQtConfig, ["publisher-attributes", "accesstypeConfig", "ATCouponGroupsIDs"], "");
  const arrCouponGroupsIDs = ATCouponGroupsIDs ? String(ATCouponGroupsIDs).split(',').map((group) => group.trim()) : [];
  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState("not-applied");
  const [isCouponEmpty, setIsCouponEmpty] = useState(false);
  const [isMandatoryCouponPlan, setIsMandatoryCouponPlan] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [plan, setPlan] = useState(selectedPlan.plan);

  useEffect(() => {
    if (plan?.id && arrCouponGroupsIDs.map(Number).includes(plan.id)) {
      setIsMandatoryCouponPlan(true);
    } else {
      setIsMandatoryCouponPlan(false);
    }
  }, [plan, arrCouponGroupsIDs]);

  async function generateAccesstypeJwt() {
    const response = await fetch("/ajax/subscription/generateJwt", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: member.email, name: member.name }),
    });
    const data = await response.json();
    return data?.token;
  }

  async function getSubscriptionPreview(jwtToken) {
    const url = `${ATBaseUrl}/api/access/v1/members/me/subscriptions/preview?key=${ATKey}&accesstype_jwt=${jwtToken}`;
    const payload = {
      subscription: {
        subscription_plan_id: plan.id,
        coupon_code: plan.coupon_code,
        payment: { payment_type: "skip_payment_gateway" },
      },
    };
    const headers = { "Content-Type": "application/json", Origin: ATOriginDomain };
    const { data } = await axios.post(url, payload, { headers });
    return data?.attempt_token;
  }

  async function createSubscription(jwtToken, attemptToken) {
    const url = `${ATBaseUrl}/api/access/v1/members/me/subscriptions?key=${ATKey}&accesstype_jwt=${jwtToken}`;
    const payload = {
      attempt_token: attemptToken,
      subscription: {
        subscription_plan_id: plan.id,
        coupon_code: plan.coupon_code,
        payment: { payment_type: "skip_payment_gateway" },
      },
    };
    const headers = { "Content-Type": "application/json", Origin: ATOriginDomain };
    const { data } = await axios.post(url, payload, { headers });
    return data;
  }

  async function handleSubscriptionCreation() {
    if (!couponCode) {
      setIsCouponEmpty(true);
      setIsCouponApplied("not-applied");
      return;
    }
    if (isCouponApplied !== "applied") {
      setIsCouponApplied("failed");
      setIsCouponEmpty(false);
      return;
    }
    setIsProcessing(true);
    try {
      const jwtToken = await generateAccesstypeJwt();
      if (!jwtToken) throw new Error("Failed to generate JWT token");

      const attemptToken = await getSubscriptionPreview(jwtToken);
      if (!attemptToken) throw new Error("Failed to get subscription preview token");

      const subscriptionData = await createSubscription(jwtToken, attemptToken);
      if (subscriptionData?.subscription?.id) {
        window.location.href = "/tilaus-onnistui";
      } else {
        window.location.href = "/tilaus-virhe";
      }
    } catch (error) {
      console.error("Subscription failed:", error);
      window.location.href = "/tilaus-virhe";
    }
  }

  /*useEffect(() => {
    const handleMessage = (event) => {
      console.log("Received message:", event);
      console.log("event.origin:", event.origin);
      console.log("event.data:", event.data);

      if (event.origin !== window.origin) return;
      const queryParams = new URLSearchParams(event.data);
      if (queryParams.has('signature')) {
        window.location.href = "/";
    }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);*/

  return (
    <div styleName="checkout-wrapper">
      <div styleName="pricing-card">
        <div>
          <div styleName="pricing-header"><h2>TILAA DEI PLUS</h2></div>
          <div styleName="checkout-container">
            {hasActiveSubscription && (
              <div styleName="active-subscription-msg">
                Sinulla on jo voimassa oleva tilaus. Voit tarkastella tilaustasi <a href="/profile">Oma profiili</a> -sivulla.
              </div>
            )}
            {member && (
              <div styleName="row-wrapper">
                <div>
                  <div styleName="label">Tili</div>
                  <span style={{ color: 'white' }}>{member.name}</span>
                  <span styleName="not-you-btn" onClick={() => setActiveTab("login")}>
                    Etkö sinä?
                  </span>
                </div>
              </div>
            )}
            <div styleName="row-wrapper">
              <div styleName="label">Tilauksen tiedot:</div>
              <div styleName="plan-preview">
                <div>
                  <div>
                    {selectedSubscriptionGroup
                      ? `${selectedSubscriptionGroup.charAt(0).toUpperCase()}${selectedSubscriptionGroup.slice(1).toLowerCase()}, `
                      : ''}
                    {plan?.title}
                  </div>
                  {/*<div styleName="price">
                  {currencyLabels?.[plan?.price_currency] && plan?.price_cents
                    ? `${currencyLabels[plan.price_currency]} ${plan.price_cents / 100}`
                    : ""}
                  </div>*/}
                </div>
              </div>
              {/*<div styleName="validity">{`Valid for ${plan.duration_length} ${
              plan.duration_length === 1
                ? plan.duration_unit.substring(0, plan.duration_unit.length - 1)
                : plan.duration_unit
            }`}</div>*/}
              {/*<div styleName="plan-and-coupon-btns">
              <div styleName="change-plan-btn" onClick={() => setActiveTab("subscription")}>
              Muuta suunnitelmaa
              </div>
              {!showCouponCode && (
                <div styleName="add-coupon-code-btn" onClick={() => setShowCouponCode(true)}>
                  Lisää kuponkikoodi
                </div>
              )}
            </div>*/}
            </div>

            {isMandatoryCouponPlan && <div styleName="row-wrapper">
              <div>
                <div styleName="label">Kuponkikoodi:</div>
                <div>
                  <input
                    styleName="coupon-code-input"
                    value={couponCode}
                    type="text"
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                  <div
                    onClick={() => {
                      setIsCouponEmpty(false);
                      setIsCouponApplied("not-applied");
                      validateCoupon(plan.id, couponCode)
                        .then((res) => {
                          if (res.valid) {
                            const updatedPlan = { ...plan };
                            updatedPlan.coupon_code = couponCode;
                            updatedPlan.discounted_price_cents = res.discount_details.discounted_price_cents;
                            updatedPlan.coupon_discount = res.discount_details.value;
                            setIsCouponApplied("applied");
                            setPlan(updatedPlan);
                          } else {
                            setIsCouponApplied("failed");
                            setPlan(selectedPlan.plan);
                          }
                        })
                        .catch((err) => console.error(`Coupon code error: ${err}`));
                    }}
                    styleName="apply-coupon-btn"
                  >
                    Käytä
                  </div>
                </div>
              </div>

              {isCouponApplied === "applied" && (
                <div styleName="amount-saved">Kuponkikoodi on voimassa. Voit nyt vahvistaa tilauksen!!</div>
              )}
              {isCouponApplied === "failed" && <div styleName="coupon-error">Tämä kuponkikoodi on virheellinen!</div>}
              {isCouponEmpty && <div styleName="coupon-error">Kuponkikoodi on pakollinen!</div>}
            </div>}

            {!isMandatoryCouponPlan && <div styleName="row-wrapper">
              <div styleName="total-payment">
                <div styleName="label">Maksamaan</div>
                <div styleName="total-payment-price-box" style={{ lineHeight: "23px" }}>{`${(plan?.discounted_price_cents !== undefined
                  ? (plan?.discounted_price_cents / 100)
                  : (plan?.price_cents ? plan.price_cents / 100 : 0)
                ).toFixed(2).replace('.', ',')
                  } ${currencyLabels[plan?.price_currency] || ""}`}</div>
              </div>
            </div>}
            <div>
              {!isMandatoryCouponPlan && <div styleName="row-wrapper" style={{ marginBottom: "15px" }}>
                <div styleName="label">Maksutapa</div>
                <input type={"radio"} id={"credit-debit-cards"} value={"razorpay"} checked />
                <label styleName="radio-label" htmlFor="credit-debit-cards">
                  Luotto-/pankkikortit
                </label>
              </div>}
              <div styleName="row-wrapper" style={{ marginBottom: "20px" }}>
                <div styleName="terms-text-container">
                  <span styleName="terms-label">
                    Hyväksy <span onClick={() => { setIsTermsModalOpen(true); setHasScrolledToBottom(false); }} styleName="terms-link-button">tilaus- ja käyttöehdot</span>
                  </span>
                  {showTermsError && <div styleName="terms-error">Hyväksy ehdot jatkaaksesi</div>}
                </div>
                <div styleName="pricing-button-wrapper">
                  {!isMandatoryCouponPlan && <button
                    styleName={`pricing-button ${hasActiveSubscription ? "disabled" : ""}`}
                    disabled={hasActiveSubscription}
                    onClick={async () => {
                      if (!isTermsAccepted) {
                        setShowTermsError(true);
                        return;
                      }
                      setShowTermsError(false);
                      const updatedPlan = JSON.parse(JSON.stringify(plan));
                      updatedPlan.coupon_code = couponCode;
                      const paytrailOptions = {
                        selectedPlan: updatedPlan,
                        planType: "standard",
                        returnUrl: `${window.location.origin}/paytrail-success.html`,
                        cancelUrl: `${window.location.origin}/paytrail-cancel.html`,
                      };

                      try {
                        const paymentResponse = await initPaytrailPayment(paytrailOptions);

                        if (paymentResponse?.subscription?.id) {
                          window.location.href = `/tilaus-onnistui`;
                        } else {
                          window.location.href = `/tilaus-virhe`;
                        }
                      } catch (error) {
                        console.log(error);
                        console.log("Payment response:", error?.error?.["payment.from_gateway"]?.[0]?.success);
                        console.log("error message output:" + error?.message);

                        // payment window closed use-case
                        if (error?.message?.toLowerCase() === "payment window closed by user") {
                          console.log("payment window is closed by the user. do nothing.");
                          return;
                        }

                        // payment failed use-case
                        if (error?.error?.["payment.from_gateway"]?.[0]?.success === false) {
                          console.log("failed payment use-case triggered.");
                          window.location.href = `/tilaus-virhe`;
                        }
                      }
                    }}
                  >
                    Maksamaan
                  </button>}
                  {isMandatoryCouponPlan && isProcessing && <div>Käsittelemme pyyntöäsi, ole hyvä ja odota hetki...</div>}
                  {isMandatoryCouponPlan && !isProcessing && <button
                    styleName={`pricing-button ${hasActiveSubscription ? "disabled" : ""}`}
                    disabled={hasActiveSubscription}
                    onClick={() => {
                      if (!isTermsAccepted) {
                        setShowTermsError(true);
                        return;
                      }
                      setShowTermsError(false);
                      handleSubscriptionCreation();
                    }}
                  >
                    Vahvista tilaus
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div styleName="bottom-red-border"></div>
      </div>

      {isTermsModalOpen && (
        <div styleName="terms-modal-overlay">
          <div styleName="terms-modal-content">
            <div styleName="terms-modal-header">
              <h2>Tilaus- ja käyttöehdot</h2>
              <button onClick={() => setIsTermsModalOpen(false)} styleName="close-terms-btn">&times;</button>
            </div>
            <div
              styleName="terms-modal-body"
              onScroll={(e) => {
                const { scrollTop, scrollHeight, clientHeight } = e.target;
                if (scrollHeight - scrollTop - clientHeight < 15) {
                  setHasScrolledToBottom(true);
                }
              }}
            >
              <KayttoehdotPage />
            </div>
            <div styleName="terms-modal-footer">
              <div styleName={`modal-checkbox-wrapper ${!hasScrolledToBottom ? 'disabled' : ''}`}>
                <input
                  type="checkbox"
                  id="modal-terms-checkbox"
                  checked={isTermsAccepted}
                  disabled={!hasScrolledToBottom}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setIsTermsAccepted(checked);
                    if (checked) {
                      setIsTermsModalOpen(false);
                      setShowTermsError(false);
                    }
                  }}
                  styleName="terms-checkbox-modal"
                />
                <label htmlFor="modal-terms-checkbox" styleName="terms-label-modal">
                  Olen lukenut ja hyväksyn tilaus- ja käyttöehdot
                </label>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

CheckoutModal.propTypes = {
  member: object,
  setActiveTab: func,
  initPaytrailPayment: func,
  selectedPlan: object,
  validateCoupon: func,
};
